import PropTypes from 'prop-types';

const PartName = ({ item }) => {
  return (
    <p className="u-fs--14 u-color--ExtraDarkGray text-uppercase text-univers--bold fw-bold pb-3">
      {item.isPartNumberDisplay && `${item.partNumber} : ${item.partName}`}
    </p>
  );
};
PartName.propTypes = {
  item: PropTypes.shape({
    partNumber: PropTypes.string,
    partName: PropTypes.string,
    isPartNumberDisplay: PropTypes.bool
  })
};
export default PartName;
